import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { AccumulatorItemComponent } from './components/accumulator-item/accumulator-item.component';
import { AccumulatorsSectionComponent } from './components/accumulators-section/accumulators-section.component';
import { CoverageItemComponent } from './components/coverage-item/coverage-item.component';
import { DentalAccumulatorsComponent } from './components/dental-accumulators/dental-accumulators.component';
import { InsurancePlanLearnMoreComponent } from './components/insurance-plan-learn-more/insurance-plan-learn-more.component';
import { TieredCoverageComponent } from './components/tiered-coverage/tiered-coverage.component';
import { TieredCoverageAmountComponent } from './components/tiered-coverage/tierred-coverage-amount/tiered-coverage-amount.component';
import { InsurancePlanCoverageComponent } from './insurance-plan-coverage.component';
import { InformativePebbleIconModule } from '../informative-icon/informative-pebble-icon.module';
import { VpgrooveModule } from '@engineering/vpgroove-angular';
import { GenesisPipesModule } from '@genesis-frontend/genesis-utilities';

@NgModule({
    imports: [
        CommonModule,
        VpgrooveModule,
        TranslateModule,
        GenesisPipesModule,
        FormsModule,
        InformativePebbleIconModule
    ],
    declarations: [
        InsurancePlanCoverageComponent,
        AccumulatorItemComponent,
        CoverageItemComponent,
        DentalAccumulatorsComponent,
        InsurancePlanLearnMoreComponent,
        TieredCoverageComponent,
        TieredCoverageAmountComponent,
        AccumulatorsSectionComponent
    ],
    exports: [
        InsurancePlanCoverageComponent,
        AccumulatorItemComponent,
        CoverageItemComponent,
        DentalAccumulatorsComponent,
        InsurancePlanLearnMoreComponent,
        TieredCoverageComponent,
        TieredCoverageAmountComponent,
        AccumulatorsSectionComponent
    ]
})
export class InsurancePlanCoverageModule {
}
